var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen h-screen flex"},[_c('div',{staticClass:"w-full h-full background-secondary md:w-1/2 px-4 lg:px-10"},[_c('nuxt')],1),_vm._v(" "),_c('div',{staticClass:"hidden md:block w-1/2",attrs:{"id":"login-image-panel"}})])}
var staticRenderFns = []

export { render, staticRenderFns }